<!--
 * @Author: Gaho
 * @Date: 2024-03-12 17:52:07
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-21 11:38:20
 * @Description: 
-->
<template>
    <div class="bet-result" :class="{'result-show': showResult }">
        <p class="result-coeficient">{{ result?.multi }}x</p>
        <span class="currency">
            <CurrentCoin class="w-[24px]" />
            <span style="font-size: 16px">
                <span style="color: #fff" class="font-digits">
                    {{ getFixed(result?.winAmount) }}
                </span>
            </span>
        </span>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'tripleResult',
    props: {
        result: {
            type: Object,
            default: () => {}
        },
        showResult: {
            type: Boolean,
            default: false
        }
    }
});
</script>
<style lang="scss" scoped>
.bet-result {
    left: 50%;
    pointer-events: none;
    position: absolute;
    align-items: center;
    background: linear-gradient(180deg, #0051cb 16.13%, #489cff 83.87%);
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    height: 100px;
    justify-content: center;
    opacity: 0;
    overflow: hidden;
    padding: 15px 10px;
    top: 25%;
    transform: translate(-50%, 10px);
    transition: all 0.3s;
    width: 200px;
    z-index: 5;
    &::before {
        animation: spin 24s linear infinite;
        background-image: url('@/assets/imgs/triple/lines-bg.webp');
        background-size: cover;
        content: '';
        height: 488px;
        margin-left: -244px;
        top: -50px;
        user-select: none;
        width: 488px;
        left: 50%;
        pointer-events: none;
        position: absolute
    }
    .result-coeficient {
        font-size: 32px;
        font-weight: 700;
        line-height: 36px;
        margin-bottom: 6px;
        text-shadow: 0 5px 12px rgba(0, 18, 81, 0.4);
    }
    .currency {
        align-items: center;
        display: inline-flex;
        flex-shrink: 0;
        .coin-img {
            margin-right: 0.5em;
        }
        .font-digits {
            font-weight: 600;
            letter-spacing: -0.5px;
            white-space: nowrap;
        }
    }
}
.result-show {
    opacity: 1;
    pointer-events: all;
    transform: translate(-50%)
}
@keyframes spin {
    100% {
        transform: rotate(1turn);
    }
}
</style>